export enum ProductAvailability {
    inStock,
    outOfStock,
}

export interface ProductBase {
    name: string;
    image: string;
    price: number;
}

export type ProductWithAvailability = ProductBase & {
    uuid: string;
    availability: ProductAvailability;
    quantity: number;
};

export interface ProductVariant {
    price?: number;
    oldPrice?: number | null;
    points?: number;
    values?: {
        uuid?: string;
    }[];
}
